import styles from 'css/src/components/agent/UpsellCard.module.scss';

import React from 'react';

import Button, { BUTTON_COLORS, TertiaryIconButton } from 'js/src/components/common/ui/Button';
import MemoizedUpsellIcon, { ICON_SIZES } from 'js/src/components/common/ui/UpsellIcon';

// The cheapest paid plan, billed annually (see web/pricing/pricing_plans.py).
const STARTING_MONTHLY_PRICE_USD = 19;

interface UpsellCardProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    showStartingPrice?: boolean;
    ctaText?: string;
    onUpgradeClick: () => void;
    onDismiss?: () => void;
    className?: string;
    children?: React.ReactNode;
}

const UpsellCard: React.FC<UpsellCardProps> = ({
    title,
    description,
    showStartingPrice = false,
    ctaText = 'Upgrade',
    onUpgradeClick,
    onDismiss,
    className = '',
    children,
}) => (
    <div className={`${styles['upsell-card']} p-l5-16 ${className}`}>
        <div className="d-flex align-items-start gap-2">
            <MemoizedUpsellIcon size={ICON_SIZES.MD} />
            <div className="flex-grow-1">
                <div className="font-l5 font-l5--regular--semibold">{title}</div>
                {description && (
                    <div className={`${styles['description']} font-l5 font-l5--small mt-l5-4`}>
                        {description}
                    </div>
                )}
            </div>
            {onDismiss && (
                <TertiaryIconButton
                    icon="close"
                    aria-label="Close upgrade offer"
                    onClick={onDismiss}
                />
            )}
        </div>
        {children}
        <div className="d-flex align-items-center gap-2 mt-l5-16">
            {showStartingPrice && (
                <div className={`${styles['price']} flex-grow-1 font-l5 font-l5--small`}>
                    Plans starting at ${STARTING_MONTHLY_PRICE_USD}/mo
                </div>
            )}
            <Button
                text={ctaText}
                color={BUTTON_COLORS.UPSELL}
                onClick={onUpgradeClick}
                className="ms-l5-auto"
            />
        </div>
    </div>
);

export default UpsellCard;
